import React, { useEffect,useState } from 'react';
import "./FoodSummary.css";
import Prev from "../../../assets/icons/coloredPrev.svg"
import { useNavigate,useLocation } from 'react-router-dom';
import useAuth from '../../../customHooks/useAuth';
import axios from "axios";
import { taxOnLines } from '../../../common/gst';
import { formatMoney } from '../../../common/money';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../common/baseUrl';
import PageLoader from '../../components/PageLoader/PageLoader';
import Remarks from '../../components/Remarks/Remarks';
import axiosInstance from '../../../axiosInstance/axiosInstance';
import { getCurrentUser } from '../../../common/currentUser';
import PromoSection, { computeDiscount } from './PromoSection';
import Dropdown from "../../components/Dropdown/Dropdown";
 
export default function FoodSummary() {
  
    const navigate = useNavigate();
    const location = useLocation();

    // The cart is editable here, so it lives in state rather than being read
    // straight off location.state on every render.
    const [foodCart, setFoodCart] = useState(location.state?.foodCart || []);
    const menu = location.state?.menu || [];
    const bookedRooms = location.state?.bookedRooms || [];
    const userId = localStorage.getItem("user_id");

    const hotelId = location.state?.hotelId || "";
    const bookingId = location.state?.bookingId || "";
    const hotelAddress = location.state?.hotelAddress || "";
    const hotelName = location.state?.hotelName || '';
    const checkInDate = location.state?.checkInDate || "";
    const checkOutDate = location.state?.checkOutDate || "";
    const status = location.state?.status || "";
    const activeTab = location.state?.activeTab || "";

    

    // Handle Refresh
    useAuth();

    // CheckId
    useEffect(()=>{
        const checkId = ()=>{
            if(bookingId==="" || hotelId===""){
                navigate("/bookings");
            }
        } 
        checkId()      
    },[bookingId,hotelId,navigate]);

    // Loading
    const [isLoading,setIsLoading] = useState(false);

    // Applied promo (offer object | null) + the discount amount in ₹
    const [appliedPromo,setAppliedPromo] = useState(null);
    const [discountAmount,setDiscountAmount] = useState(0);

    const numericTotal = foodCart.reduce(
        (sum, item) => sum + (Number(item.price) || 0) * item.quantity, 0,
    );
    const discountedTotal = Math.max(0, numericTotal - discountAmount);

    // Same basis the backend uses: GST is charged on the discounted amount, per item rate.
    const taxTotal = taxOnLines(
        foodCart.map((item) => ({
            amount: (Number(item.price) || 0) * item.quantity,
            gst_percentage: item.gst_percentage,
        })),
        numericTotal,
        discountAmount,
    );
    const payableTotal = discountedTotal + taxTotal;

    // Changing quantities moves the order total, so an applied coupon is
    // re-evaluated against it: recalculated, or dropped if the order has fallen
    // below the coupon's minimum.
    const updateQuantity = (menuItemId, nextQuantity) => {
        const updatedCart = nextQuantity <= 0
            ? foodCart.filter(item => item.menu_item_id !== menuItemId)
            : foodCart.map(item =>
                item.menu_item_id === menuItemId
                    ? { ...item, quantity: nextQuantity }
                    : item);

        setFoodCart(updatedCart);

        if (!appliedPromo) {
            return;
        }

        const updatedTotal = updatedCart.reduce(
            (sum, item) => sum + (Number(item.price) || 0) * item.quantity, 0,
        );
        const updatedDiscount = computeDiscount(appliedPromo, updatedTotal);

        if (updatedDiscount === 0) {
            toast.info(`${appliedPromo.code} removed, the order is below its minimum`);
            setAppliedPromo(null);
            setDiscountAmount(0);
            return;
        }

        setDiscountAmount(updatedDiscount);
    };

    const handleApplyPromo = (offer, discount) => {
        setAppliedPromo(offer);
        setDiscountAmount(discount);
    };

    const handleRemovePromo = () => {
        setAppliedPromo(null);
        setDiscountAmount(0);
    };

    // Form data
    const [formData,setFormData] = useState({
        roomNum : "",
        comments : ""
    });

    // State for managing errors
    const [errors, setErrors] = useState({
        room: { id: "", room_number: "" },
        comments: ""
    });

    // Handle Change function
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        validateField(name, value);  // Validate each field using its name
    };


    // Validation for individual fields
    const validateField = (name, value) => {
        const newErrors = { ...errors };

        switch (name) {
            case "roomNum":
                if (value.trim() === "") {
                    newErrors.roomNum = "Room selection is required";
                } else {
                    newErrors.roomNum = "";
                }
                break;

            // case "comments":
            //     if (value.trim() === "") {
            //         newErrors.comments = "Comments are required";
            //     } else if (value.length < 10) {
            //         newErrors.comments = "Comments must be at least 10 characters";
            //     } else {
            //         newErrors.comments = "";
            //     }
            //     break;

            default:
                break;
        }

        setErrors(newErrors);
    };

    // Validate entire form before submission
    const validateForm = () => {
        const newErrors = {};

        if (!formData.roomNum.trim()) {
            newErrors.roomNum = "Room selection is required";
        }

        // if (!formData.comments.trim()) {
        //     newErrors.comments = "Comments are required";
        // } else if (formData.comments.length < 10) {
        //     newErrors.comments = "Comments must be at least 10 characters";
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
 
    // Move Back
    const moveBack = ()=>{
        navigate(`/bookings/${bookingId}/requests/new/food`,{state : {
            foodCart : foodCart,
            menu : menu,
            bookedRooms : bookedRooms,
            totalPrice : numericTotal,
            hotelId : hotelId,
            bookingId : bookingId,
            hotelAddress : hotelAddress,
            hotelName : hotelName,
            checkInDate : checkInDate,
            checkOutDate : checkOutDate,
            status  : status,
            activeTab : activeTab,
        }})
    }

    // Handle Submit 
    const handleSubmit = async()=>{
        try{
            if(validateForm()){
                try{
                    setIsLoading(true);
                    // console.log("Form Will Be Submited");
                    // console.log("Form Data : ",formData);
                    const roomData = bookedRooms.find(item=>item.id===formData.roomNum);
                    // console.log("Room Number : ",roomData.room_number);
    
                    const passData = {
                        service_room : roomData.room_number,
                        additional_comments : formData.comments.trim(),
                        food_items : foodCart,
                        promo_code : appliedPromo?.code || ""
                    }
    
                    const currentUser = await getCurrentUser();
     
                    function findMatchedRooms(bookedRooms, usersData) {
                        const contact = usersData.contact;
                        const matchedRooms = bookedRooms.filter((room)=>{
                            // Check if guests are null or an empty array, and skip the room if true
                            if (!room.guests || room.guests.length === 0) {
                                return false; // Skip this room
                            }
                            const matchedGuest = room.guests.find((guest)=>guest.contact===contact);
                            if(matchedGuest) {
                                return true; //
                            }
                            else{
                                return false;
                            }
                        });
                        return matchedRooms;
                    }        
              
                    const usersData = currentUser;  
                    const matchedRooms = findMatchedRooms(bookedRooms, usersData);
    
                    console.log("Matched Rooms : ",matchedRooms);
                    // return;
              
                    if(matchedRooms.length<=0){
                      console.log("Booking is not Present ");
                      return;
                    }
                    // console.log("MAtched Rooms : " + matchedRooms[0].id);
     
                    const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${matchedRooms[0].id}/guest-requests/post-checkin/food-request/`,passData);

                    // console.log("Food Request Added : ",response.data);
                    // Prefer the server-authoritative discount for the confirmation message.
                    const savedAmount = response?.data?.discount_amount ?? (appliedPromo ? discountAmount : 0);
                    if (savedAmount > 0) {
                        toast.success(`Food Request Created! You saved ₹${formatMoney(savedAmount)} 🎉`);
                    } else {
                        toast.success("Food Request Created Successfully");
                    }
                    navigate("/bookings",{state : {activeRequests : "requests"}})
                }catch(error){
                    toast.error(error?.response?.data?.message || "Some Error Occured");
                    console.log(error);
                }
    
            }else{
                console.log("Form has Some Error");
            }
        }catch(error){
            console.log(error)
        }
        finally{
            setIsLoading(false);
        }
    }
  
    return (
        <>
            {
                isLoading && <PageLoader/>
            }
            <div className="foodSummary">
                <div className="foodSummary-header">
                    <img src={Prev} alt="Error" onClick={moveBack} />
                    <h3>Food Order Summary</h3>
                </div>

              
                <div className="foodSummary-data">
                    {foodCart.length === 0 && (
                        <div className="foodSummary-empty">
                            <p>Your order is empty.</p>
                            <button onClick={moveBack}>Back to menu</button>
                        </div>
                    )}

                    {foodCart.map((cart)=>(
                        <div className="foodSummary-order" key={cart.menu_item_id}>
                            <div className="foodSummary-name">
                                <p>{cart.name}</p>
                                <span>{cart.price} ₹ each</span>
                            </div>
                            <div className="foodSummary-qty">
                                <button
                                    onClick={() => updateQuantity(cart.menu_item_id, cart.quantity - 1)}
                                    aria-label={`Remove one ${cart.name}`}
                                >-</button>
                                <span>{cart.quantity}</span>
                                <button
                                    onClick={() => updateQuantity(cart.menu_item_id, cart.quantity + 1)}
                                    aria-label={`Add one ${cart.name}`}
                                >+</button>
                            </div>
                            <div className="foodSummary-price">
                                <p>{(Number(cart.price) || 0) * cart.quantity} ₹</p>
                            </div>
                        </div>
                    ))}
                </div>

                <PromoSection
                    userId={userId}
                    hotelId={hotelId}
                    service="In Room Dining"
                    orderAmount={numericTotal}
                    appliedPromo={appliedPromo}
                    discountAmount={discountAmount}
                    onApply={handleApplyPromo}
                    onRemove={handleRemovePromo}
                />

                <div className="foodSummary-bill">
                    <div className="foodSummary-bill-row">
                        <p>Subtotal</p>
                        <p>{formatMoney(numericTotal)} ₹</p>
                    </div>
                    {appliedPromo && (
                        <div className="foodSummary-bill-row foodSummary-bill-discount">
                            <p>Discount ({appliedPromo.code})</p>
                            <p>- {formatMoney(discountAmount)} ₹</p>
                        </div>
                    )}
                    {taxTotal > 0 && (
                        <div className="foodSummary-bill-row">
                            <p>GST</p>
                            <p>+ {formatMoney(taxTotal)} ₹</p>
                        </div>
                    )}
                    <div className="foodSummary-bill-row foodSummary-bill-total">
                        <h4>Total</h4>
                        <h4>{formatMoney(payableTotal)} ₹</h4>
                    </div>
                </div>

                <div className='food-note'>
                    <h4><span>Note :</span> {taxTotal > 0 ? 'total includes GST' : 'no GST applies to this order'}</h4>
                </div>

                <div className="foodSummary-comment">
                    <div className="comment-label">
                        <h5>Comments</h5>
                    </div>
                    <div className="comment-input">
                        <textarea rows="10" cols="30" name="comments" value={formData.comments} onChange={handleChange} />
                    </div>
                    {errors.comments && <p className="error-message">{errors.comments}</p>} 
                </div>

                <div className="foodSummary-service">
                    <h5>Service Room</h5>
                    <div className="foodSummary-order">
                        <div className="foodSummary-room">
                            <Dropdown
                                name="roomNum"
                                value={formData.roomNum}
                                onChange={handleChange}
                                placeholder="Select Room"
                                options={bookedRooms
                                    .filter(room => room.room_number)
                                    .map(room => ({ value: room.id, label: String(room.room_number) }))}
                            />
                            {errors.roomNum && <p className="error-message">{errors.roomNum}</p>}
                        </div>
                        <div className="foodSummary-button">
                            <button onClick={handleSubmit} disabled={formData.roomNum==="" || foodCart.length===0} >Send Request</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
